__turbopack_context__.v({
  "communityContainer": "JUqPJa_communityContainer",
  "iconContainer": "JUqPJa_iconContainer",
  "icons": "JUqPJa_icons",
  "text": "JUqPJa_text",
});
